<template>
  <div>
    <button
      v-for="{ value, title, caption } in options"
      :key="value"
      class="ml-4 w-full flex items-center text-black py-2 text-left focus:outline-hidden"
      :data-label="dataLabel"
      :data-action="value"
      @click="select(value)"
    >
      <span v-show="active(value)">
        <FaIcon :icon="['fal', 'check-square']" class="text-3xl text-primary" />
      </span>
      <span v-show="!active(value)">
        <FaIcon :icon="['fal', 'square']" class="text-3xl text-gray-500" />
      </span>
      <span class="ml-4 text-md">{{ fetchTitle({ title, caption }) }}</span>
    </button>
  </div>
</template>

<script setup>
defineProps({
  options: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every(
        (item) =>
          typeof item.value === "string" &&
          typeof item.title === "string" &&
          ["string", null, undefined].includes(typeof item.caption),
      )
    },
  },
  dataLabel: {
    type: String,
    required: false,
  },
  select: {
    type: Function,
    required: true,
  },
  active: {
    type: Function,
    required: true,
  },
})
const fetchTitle = ({ title, caption }) => {
  if (caption) title += ` (${caption})`
  return title
}
</script>

<script>
export default {
  name: "OptionsList",
}
</script>
